import React, { ComponentProps } from "react";

import { showDialogAsync } from "../../dialog-queue";
import { PendingUploadsDialogContainer } from "./pending-uploads-dialog-container";
import { preprocessProgressState } from "../../../hooks/use-photo-preprocess-progress";

const showPendingUploadsDialogAsync = (
	flow?: ComponentProps<typeof PendingUploadsDialogContainer>["flow"],
) =>
	showDialogAsync<undefined | false>(
		({ resolve }, { isOpen }) => (
			<PendingUploadsDialogContainer open={isOpen} onClose={resolve} flow={flow} />
		),
		{
			allowOther: true,
		},
	);

export const waitForPendingUploadsAsync = (
	{
		getHasPendingUploads,
	}: {
		getHasPendingUploads: () => boolean;
	},
	{
		flow = "general",
	}: {
		flow?: ComponentProps<typeof PendingUploadsDialogContainer>["flow"];
	} = {},
) => {
	const preprocessProgress = preprocessProgressState.progress;
	const isPreprocessingPhotosToUpload =
		!!preprocessProgress && preprocessProgress?.progressCount !== preprocessProgress?.total;
	return getHasPendingUploads() || isPreprocessingPhotosToUpload
		? showPendingUploadsDialogAsync(flow).then(
				(hasPendingUploads) => hasPendingUploads === false,
		  )
		: Promise.resolve(true);
};
